import VisitorsPageView from "./VisitorsPageView";

function VisitorsPage() {
  return <VisitorsPageView />;
}

export default VisitorsPage;
